import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchMenu } from '../redux/actions';
import slug from 'slug';
import Helmet from 'react-helmet';
import './MenuPage.css';

import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import FullbleedContentBlock from '../components/ContentBlocks/FullbleedContentBlock';
import RenderProduct from '../components/RenderProduct';
import RenderCategory from '../components/RenderCategory';

class MenuPage extends Component {

  componentDidMount() {
    const locale = this.props.intl.locale;

    if (!this.props.menus.length) {
      this.props.fetchMenu(this.props.date, locale);
    }
  }

  componentDidUpdate() {
    const menuSlug = this.props.match.params.slug;

    const menus = this.props.menus;
    const menu = (menus.find(menu => slug(menu.fields.title.toLowerCase()) === menuSlug));

    if (menus.length && !menu) {
      this.props.history.replace('/menu');
    }
  }

  render() {
    const isItemValid = (item, time) => {
      return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
        && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
    }

    const menuSlug = this.props.match.params.slug;
    const menuSubSlug = this.props.match.params.subslug;
    const {menus, categories, products} = {...this.props};

    const productGroups = categories.filter(category => isItemValid(category, this.props.date));

    return (
      <div className="menu">
        {menus && menus.map((menu) => {
          if (menuSlug !== slug(menu.fields.title.toLowerCase())) {
            return null;
          }

          return (
            <div key={menu.fields.title} style={{backgroundImage: `url(${menu.fields.image.fields.file.url})`}}>
              <Helmet title={menu.fields.title} />
              { menu.fields.specialDiets &&
                <div className="special-diets">
                  <FullbleedHero key={menu.sys.id} fields={{
                    heading: menu.fields.title,
                    lead: menu.fields.description,
                    image: menu.fields.image
                  }} />
                </div>
              }
              { !menu.fields.specialDiets &&
              <div className={'category cols-'+menu.fields.columns} id={slug(menu.fields.title.toLowerCase())}>
                  <FullbleedContentBlock key={menu.sys.id} align="center" fields={{
                    heading: menu.fields.longTitle ? menu.fields.longTitle : menu.fields.title
                  }} />
                  <div className="container">
                    {menu.fields.children && 
                      <nav className="subcategory-nav">
                      {menu.fields.children.map((child) => {
                        let category = productGroups.find((p) => {
                          return p.sys.id === child.sys.id
                        })

                        if(category) {
                          return(
                            <NavLink to={'/menu/'+menuSlug+'/'+slug(category.fields.title.toLowerCase())} key={category.sys.id} activeClassName="active">{category.fields.title}</NavLink>
                          )
                        }

                        return null;
                      })}
                      </nav>
                    }
                    <div className="products-wrapper">
                      <div className="products-categories">
                        {menu.fields.children && menu.fields.children.map((child, index) => {
                          let product = products.find((p) => {
                            return p.sys.id === child.sys.id
                          })
                          let category = productGroups.find((p) => {
                            return p.sys.id === child.sys.id
                          })

                          if(product) {
                            return(
                              <RenderProduct product={product} key={product.fields.title} {...this.props} />
                            )
                          }

                          if(category && slug(category.fields.title.toLowerCase()) === menuSubSlug) {
                            return(
                              <RenderCategory category={category} key={category.fields.title} {...this.props} />
                            )
                          }

                          return null;
                        })}
                      </div>
                      {menu.fields.children && menu.fields.children.map((child) => {
                        let menu = menus.find((p) => {
                          return p.sys.id === child.sys.id
                        })

                        if(menu) {
                          return(
                            <div className={'submenu cols-'+menu.fields.columns} key={menu.fields.title} id={slug(menu.fields.title.toLowerCase())}>
                              <h3>{menu.fields.title}</h3>
                              {menu.fields.description && <p>{menu.fields.description}</p>}
                              {menu.fields.children && menu.fields.children.map((child) => {
                                let product = products.find((p) => {
                                  return p.sys.id === child.sys.id
                                })
                                let category = productGroups.find((p) => {
                                  return p.sys.id === child.sys.id
                                })
                                if(product) {
                                  return(
                                    <RenderProduct product={product} key={product.fields.title} {...this.props} />
                                  )
                                }

                                if(category) {
                                  return(
                                    <RenderCategory category={category} key={category.fields.title} {...this.props} />
                                  )
                                }

                                return null;
                              })}
                            </div>
                          )
                        }
                        return null;
                      })}
                    </div>
                  </div>
              </div>
            }
            </div>
          )})
        }
      </div>
    );
  }
}

MenuPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  menus:state.menus,
  date:state.date,
  products:state.products,
  categories:state.categories
});

const mapDispatchToProps = {
  fetchMenu
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(MenuPage));



// WEBPACK FOOTER //
// ./src/containers/MenuPage.js